import { render, staticRenderFns } from "./send.vue?vue&type=template&id=0e9535f6"
import script from "./send.vue?vue&type=script&lang=js"
export * from "./send.vue?vue&type=script&lang=js"
import style0 from "./send.vue?vue&type=style&index=0&id=0e9535f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports